import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import { RequestProps } from '../../store/types'
import defaultProps from '../../config/defaultProps'
import { useGetPermissionsQuery } from '../../store/redux/reducers/permissionsSlice'
import { Column, Row } from '../../store/types/utils/DataTableUtils'
import { Box, TableCell, Tooltip, Typography } from '@mui/material'
import { StyledPageContent } from '../../styles/PageStyles'
import DataTable from './DataTable'
import Searchbar from '../Searchbar/Searchbar'
import LocalStorageTypes from '../../store/types/enums/LocalStorageTypes'
import SessionStorageKeys from '../../store/types/enums/SessionStorageKeys'
import usePersistedPage from '../../store/utils/usePersistedPage'

const PermissionsTable = () => {
  const { t } = useTranslation()
  const [page, setPage] = usePersistedPage(SessionStorageKeys.PermissionsTablePage)
  const [requestProps, setRequestProps] = useState<RequestProps>(defaultProps)

  const { data: permissionsResponse, isLoading } = useGetPermissionsQuery(requestProps)

  const columns: Column[] = [{ id: 'id', label: t('components.table.header.permissionName') }]

  const handleSearch = (value: string) => {
    setRequestProps({ ...requestProps, 'query:id': value, page: 0 })
    setPage(0)
  }

  const renderPermissionTileContent = (permission: Row, labelId: string, _checkbox?: React.ReactNode) => {
    return (
      <Tooltip title={permission.id}>
        <Typography key={labelId} variant="h6" textOverflow={'ellipsis'} overflow={'hidden'}>
          {permission.id}
        </Typography>
      </Tooltip>
    )
  }

  const renderRow = (permission: Row) => {
    return (
      <>
        <TableCell sx={{ height: 52 }}>
          <Typography>{permission.id}</Typography>
        </TableCell>
      </>
    )
  }

  return (
    <StyledPageContent display={'flex'} flexDirection={'column'} gap={'24px'} color={'text.light'}>
      <Searchbar placeholder={t('components.placeholder.search')} handleChange={handleSearch} />
      <Box
        display={'flex'}
        flexDirection={{ xs: 'column', md: 'row' }}
        justifyContent={'space-between'}
        gap={0}
        height={'fit-content'}
      >
        <DataTable
          renderTileContent={(permission: Row, labelId: string, checkbox?: React.ReactNode) =>
            renderPermissionTileContent(permission, labelId, checkbox)
          }
          singleSelection={false}
          columns={columns}
          data={permissionsResponse?.content || []}
          renderRow={renderRow}
          totalElements={permissionsResponse?.totalElements || 0}
          setRequestProps={setRequestProps}
          translationForNotFound={t('page.adminsPage.accessibility.permissionsNotFound')}
          page={page}
          setPage={setPage}
          isLoading={isLoading}
          removeCheckboxes
          hoverOff
          isLastCellNormal={true}
          commonRowsPerPage={
            localStorage.getItem(LocalStorageTypes.PermissionsRows)
              ? parseInt(localStorage.getItem(LocalStorageTypes.PermissionsRows)!)
              : undefined
          }
          localStorageRowsName={LocalStorageTypes.PermissionsRows}
        />
      </Box>
    </StyledPageContent>
  )
}

export default PermissionsTable
